import React from 'react';
import { Grid } from '@mui/material';
import { InfoCard } from 'sharedComponents/UI';
import BoardNodeContainer from 'components/common/SparkOutputBoard/BoardNodeContainer';
import { useBoardNodeTypes } from 'hooks/EntityTypes/useBoardNodeTypes';
import type { BoardNodes } from 'types/BoardNode';

type BoardListViewContainerProps = {
  boardNodes?: BoardNodes[];
};

function SparkOutputPreviewBoardListViewContainer({
  boardNodes,
}: BoardListViewContainerProps) {
  const { idMap: boardNodeTypesIdMap } = useBoardNodeTypes();

  if (!boardNodes?.length) {
    return (
      <InfoCard
        cardStyles={{ margin: 2, width: '100%' }}
        info='No output'
        type='warning'
      />
    );
  }

  return (
    <Grid container style={{ width: '100%' }} gap={2}>
      {boardNodes?.map((boardNode) => (
        <BoardNodeContainer
          key={boardNode?.id}
          boardNode={boardNode}
          readOnly={true}
          isCanvasView={false}
          isHover={false}
          shouldResolveReference={true}
          nodeType={boardNodeTypesIdMap?.[boardNode.attributes.boardNodeTypeID]}
        />
      ))}
    </Grid>
  );
}

// Memoize the component to avoid unnecessary re-renders
export default React.memo(SparkOutputPreviewBoardListViewContainer);
